import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import IconButton from '@mui/material/IconButton';
import { AppLogo } from '../../../components/common';
import AdminNotificationsBell from './AdminNotificationsBell';

interface Props {
  onMenuOpen: () => void;
}

export default function AdminAppNavbar({ onMenuOpen }: Props) {
  return (
    <AppBar
      position="fixed"
      color="default"
      elevation={0}
      sx={{
        display: { xs: 'block', md: 'none' },
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      <Toolbar variant="regular" sx={{ gap: 1 }}>
        <IconButton onClick={onMenuOpen} edge="start" aria-label="Open menu">
          <MenuRoundedIcon />
        </IconButton>
        <Box sx={{ height: 40, display: 'flex', alignItems: 'center' }}>
          <AppLogo variant="navbar" to="/admin/dashboard" />
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        <AdminNotificationsBell />
      </Toolbar>
    </AppBar>
  );
}
